import { useContext, useState } from "react";
import {
	AppBar as MuiAppBar,
	Toolbar,
	Button,
	Box,
	Typography,
} from "@gti-controls-v2/web-core";
import {
	AccountCircle,
	ArrowDropUp,
	ArrowDropDown,
	MenuOpen,
} from "@gti-controls-v2/web-core"; //iconos
import Popover from "./popover";
import PopoverUsuario from "./popover-usuario";
import homePageStyles from "../../common/styles/HomePage";
import logo from "../../assets/images/logo-masorden-gris-small.svg"
import MediaQuery from "react-responsive";
import { useMediaQueryCustom } from "../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import customTheme from "../../theme";
import { AuthContext } from "../../providers/auth";
import { SettingsContext } from "../../providers/settings";

export const AppBar = (props) => {

	const { user } = useContext(AuthContext);
	const { toggleMenu } = useContext(SettingsContext); 
	const { isMobile480, isTablet768, isTablet1024 } = useMediaQueryCustom();
	const styles = homePageStyles;
	const [anchorEl, setAnchorEl] = useState(null);
	const [activePopover, setActivePopover] = useState(null);

	const handlePopoverClick = (event, name) => {
		setAnchorEl(event.currentTarget);
		setActivePopover(name);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setActivePopover(null);
	};

	return (
		<MuiAppBar sx={styles.appBar} position="relative">
			<Toolbar
				style={{
					height: isMobile480 ? customTheme.spacing(5) : isTablet768 ? customTheme.spacing(6) : isTablet1024 ? customTheme.spacing(6) : customTheme.spacing(8),
					minHeight: isMobile480 ? customTheme.spacing(5) : isTablet768 ? customTheme.spacing(6) : isTablet1024 ? customTheme.spacing(6) : customTheme.spacing(8)
				}}
			>	
				<Box>
					<Button
						id={"Button_AppBar_Menu"}
						disableElevation
						aria-haspopup="true"
						disableRipple
						startIcon={<MenuOpen sx={styles.accountIcon}/>}
						onClick={() => {
							toggleMenu();
						}}
					/>
				</Box>
				
				<Box>
					
					<img src={logo} width={isMobile480 ? "100px" : isTablet768 ? "110px" : "120px"} alt="Logo gris masorden" style={{ verticalAlign: "middle" }} />
				</Box>

				<Box sx={styles.spacer} />

				<Box sx={styles.logout}>
					<Button
						id={"Button_AppBar_Usuario"}
						disableElevation
						variant="text"
						aria-haspopup="true"
						disableRipple
						startIcon={<AccountCircle sx={styles.accountIcon}/>}
						endIcon={
							activePopover === "user" ? <ArrowDropUp sx={styles.accountIcon} /> : <ArrowDropDown sx={styles.accountIcon} />
						}
						onClick={(e) => {
							handlePopoverClick(e, "user");
						}}
						
					>
						<MediaQuery minWidth={768}>
							<Typography style={styles.accountUsername}
								fontSize={isMobile480 ? "12px" : isTablet768 ? "14px" : isTablet1024 ? "14px" : "20px"}>
								{user?.usuarioNombre}
							</Typography>
						</MediaQuery>
					</Button>
					<Popover
						id="user"
						open={activePopover === "user"}
						anchorEl={anchorEl}
						onClose={handleClose}
					>
						<PopoverUsuario />
					</Popover>
				</Box>
			</Toolbar>
		</MuiAppBar>
	);
};

export default AppBar;
